const initialState = {
  availabilityList: null,
  motivesList: [],
  callAvailable: false
}
export default function(state = initialState, action){
    switch(action.type){
        case "SET_AVAILABILITY_DETAIL":
            return {
              ...state,
              availabilityList: action.payload
            }
        case "MODIFY_AVAILABILITY_DETAIL":
            return Object.assign( {}, state, { availabilityList: Object.assign( {}, state.availabilityList, action.payload )});
        case "SET_MOTIVES_LIST":
            return {
              ...state,
              motivesList: action.payload
            }
        case "SET_CALL_AVAILABILITY":
            return {
              ...state,
              callAvailable: action.payload.available
            }
        case "SET_CALL_MOTIVES_LIST":
          return {
            ...state,
            availabilityList: action.payload[0],
            motivesList: action.payload[1],
          }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/availability.js